import React from "react"

import { validateField } from "@/utils/helper"

import Input from "@/components/core/Input/Input"
import RadioButton from "@/components/core/RadioButton/RadioButton"

const WithProfessional = props => {
  const {
    i18n = {},
    data = {},
    setData = () => {},
    radioKeyDown = () => {},
    onBlur = () => {},
    error = {},
  } = props
  return (
    <div
      className="optional-form professional-group"
      role="radiogroup"
      aria-labelledby="with-professional-radio"
    >
      <div id="with-professional-radio" className="question">
        {i18n?.workingWithProfessional}
      </div>
      <div className="radio-section">
        <div className="radio-wrapper">
          <RadioButton
            id={"with-professional"}
            name={"with-professional"}
            value={i18n?.yes}
            checked={data?.active}
            onClick={() => setData({ active: true })}
            onKeydown={radioKeyDown}
          />
          <RadioButton
            id={"without-professional"}
            name={"with-professional"}
            value={i18n?.no}
            checked={!data?.active}
            onClick={() => setData({ active: false })}
            onKeydown={radioKeyDown}
          />
        </div>
        {data?.active && (
          <div className="form-wrapper">
            <Input
              id="kf-professional-name"
              type="text"
              value={data?.professionalName || ""}
              maxLength={50}
              placeholder={`${i18n?.contactName}*`}
              label={`${i18n?.contactName}*`}
              showError={error?.professionalName}
              errorMessage={error?.professionalName}
              onChange={async e => {
                const { value } = e.target
                if ((await validateField("name", value)) || value === "") {
                  setData({ ...data, professionalName: value })
                }
              }}
              onBlur={() => onBlur("professionalName")}
            />
            <Input
              id="kf-professional-company"
              type="text"
              value={data?.company || ""}
              maxLength={50}
              placeholder={`${i18n?.companyName}*`}
              showError={error?.company}
              errorMessage={error?.company}
              label={`${i18n?.companyName}*`}
              onChange={async e => {
                const { value } = e.target
                if (
                  (await validateField("contactusCompanyName", value)) ||
                  value === ""
                ) {
                  setData({ ...data, company: value })
                }
              }}
              onBlur={() => onBlur("company")}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default WithProfessional
